import React from 'react';
import Flagship from '../../core/flagship';
import {Link, browserHistory} from 'react-router';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../../actions/appActions';
import SingleRecordFiles from '../records/SingleRecordFiles';
import SingleRecordHeader from '../records/SingleRecordHeader';
import CommentBox from '../records/CommentBox';
import Attachments from '../records/Attachments';
import FavoriteIcon from '../records/FavoriteIcon';
import SubscribeButton from '../records/SubscribeButton';
import SingleRecordView from '../records/SingleRecordView';
import SingleRecordEdit from '../records/SingleRecordEdit';
import {mergeDeep, empty, isEqual} from '../../utils/helpers';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../../styles/singleRecord.scss';
import LineItemBox from '../records/LineItemBox';
import IoProductBox from '../records/IoProductBox';
import {Grid, Table, Loader, Header, Button, Icon, Segment, Modal, Label, Divider} from 'semantic-ui-react';

class SingleRecord extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = this.getInitialState();
        this.getRecordData = this.getRecordData.bind(this);
        this.saveAndExit = this.saveAndExit.bind(this);
        this.cancelExit = this.cancelExit.bind(this);
        this.saveRecord = this.saveRecord.bind(this);
        this.abandonChanges = this.abandonChanges.bind(this);
        this.editModeChange = this.editModeChange.bind(this);
        this.recordNameChange = this.recordNameChange.bind(this);
        this.extraChange = this.extraChange.bind(this);
        this.onAddLineItem = this.onAddLineItem.bind(this);
        this.onStatusChange = this.onStatusChange.bind(this);
        this.checkRequired = this.checkRequired.bind(this);
        this.hasContract = this.hasContract.bind(this);
        this.onChangeLaunchDate = this.onChangeLaunchDate.bind(this);
        this.cancelLaunchDateChange = this.cancelLaunchDateChange.bind(this);
        this.saveLaunchDate = this.saveLaunchDate.bind(this);
        this.getViewingParams = this.getViewingParams.bind(this);
        this.onCloseModals = this.onCloseModals.bind(this);
        this.duplicateRecord = this.duplicateRecord.bind(this);
        this.renderLineItems = this.renderLineItems.bind(this);
        this.hasLineItems = this.hasLineItems.bind(this);
        this.onCancelRecord = this.onCancelRecord.bind(this);
        this.onSubmitRecord = this.onSubmitRecord.bind(this);
        this.onReactivateRecord = this.onReactivateRecord.bind(this);
    }

    getViewingParams(nextProps = false) {

        let key = (nextProps === false ? this.props.routeParams.splat : nextProps.routeParams.splat);
        let viewingChild = false;

        let parts = key.split("/");

        if (parts.length > 1) {
            key = parts[0];
            if (parts[1] === "focus") {
                viewingChild = parts[2];
            }
        }

        return {
            key,
            viewingChild
        }
    }

    getInitialState(nextProps = false) {

        return Object.assign(this.getViewingParams(nextProps), {
            editing: false,
            inputValue: false,
            confirmExit: false,
            recordData: {},
            nextLocation: '',
            modified: false,
            errors: [],
            requiredMissing: false,
            showLaunchDateModal: false,
            launchDate: moment(),
            hasLineItems:null,
            hasContract:false
        });
    }

    componentWillMount() {
        setTimeout(Flagship.closeSidebarNav,500);
    }

    componentDidMount() {
        this.getRecordData();
        document.title = (this.props.route.mode === "edit" ? 'Editing ' : '') + this.props.route.niceName + ' / Loading...';
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.route.path !== this.props.route.path) {

            this.setState(
                this.getInitialState(nextProps),
                this.getRecordData
            );
        } else {

            this.setState(
                this.getViewingParams(nextProps),
                this.getRecordData
            );
        }
    }

    onCloseModals() {
        let baseUrl = window.location.pathname.substr(0, window.location.pathname.indexOf('/focus/'));
        if (!empty(baseUrl)){
            this.props.router.push(baseUrl);
        }
    }

    onSubmitRecord() {

        let self = this;

        Flagship.changeRecordStatus(
            this.state.recordData.record.id,
            "publish",
            function(response) {
                if ( response.data.success === true ) {
                    Flagship.notify( self.props.route.niceName + " submitted!", "success");
                    Flagship.event(
                        "submit-" + self.props.route.type,
                        {
                            recordData: self.state.recordData.record
                        },
                        self.state.recordData.record.id,
                        self.props.userId
                    );
                } else {
                    Flagship.notify( "An error occurred..", "error");
                }
                self.getRecordData();
            }
        );
    }

    onCancelRecord() {

        let self = this;

        Flagship.changeRecordStatus(
            this.state.recordData.record.id,
            "trash",
            function(response) {
                if ( response.data.success === true ) {
                    Flagship.notify( self.props.route.niceName + " canceled.", "success");
                } else {
                    Flagship.notify( "An error occurred..", "error");
                }
                self.getRecordData();
            }
        );
    }

    onReactivateRecord() {

        let self = this;

        Flagship.changeRecordStatus(
            this.state.recordData.record.id,
            "draft",
            function(response) {
                if ( response.data.success === true ) {
                    Flagship.notify( self.props.route.niceName + " resurrected.", "success");
                } else {
                    Flagship.notify( "An error occurred..", "error");
                }
                self.getRecordData();
            }
        );
    }

    hasLineItems(value = true) {
        this.setState({
            hasLineItems: value
        });
    }


    getRecordData() {
        console.log("GRD");
        let key = this.state.key;
        let type = this.props.route.type;
        let self = this;

        Flagship.get(
            'records/' + type + '/' + key,
            {},
            function(response) {
                if (response.data.success === true) {

                    self.setState({
                        recordData: response.data,
                        nextLocation: "/" + response.data.record.record_type + "/view/" + response.data.record.record_key
                    });
                    localStorage.setItem('initialRecordData', JSON.stringify(response.data));

                    document.title = (self.props.route.mode === "edit" ? 'Editing ' : '') +
                                    self.props.route.niceName + ' / ' + self.state.recordData.record.record_name;

                } else {
                    Flagship.error("Error getting record '" + key + "' from Flagship API server.", null, self.props.userId);
                }
            },
            function(err) {
                Flagship.error("Error getting record '" + key + "' from Flagship API server: " + err, null, self.props.userId);

            }
        );
    }

    isFavorite() {
        let userHasFavorited = false;
        let currentUserId = this.props.userId;

        if ( this.state.recordData.favorited.length > 0 ){
            this.state.recordData.favorited.map(function(user) {
                if (parseInt(user.user_id) === currentUserId) {
                    userHasFavorited = true;
                }
            });
        }
        return userHasFavorited;
    }

    editModeChange(e, newFieldValue, field) {

        let newRecordData = mergeDeep({}, this.state.recordData);

        let match = newRecordData.data.filter(function( item ) {
            return item.id === field.field_id || item.field_id === field.field_id;
        });

        let newIndex = newRecordData.data.indexOf(match[0]);

        if (newIndex === -1) {
            let newField = mergeDeep({}, field);
            newField.field_value = newFieldValue;
            newField.field_id = field.field_id;
            newRecordData.data.push(newField);
        } else {
            newRecordData.data[newIndex].field_value = newFieldValue;
            newRecordData.data[newIndex].field_id = field.field_id;
        }


        window.onbeforeunload = function(e) {
            let text = "Are you sure you want to leave Flagship?";
            e.returnValue = text;
            return text;
        };

        this.setState(
            {
                modified: true,
                recordData: newRecordData
            }, this.checkRequired
        );
    }


    recordNameChange(e, newName) {
        let newRecordData = mergeDeep({}, this.state.recordData);
        newRecordData.record.record_name = newName;

        window.onbeforeunload = function(e) {
            let text = "Are you sure you want to leave Flagship?";
            e.returnValue = text;
            return text;
        };

        this.setState(
            {
                modified: true,
                recordData: newRecordData
            }, this.checkRequired
        );
    }

    extraChange(e, newValue, which) {
        let newRecordData = mergeDeep({}, this.state.recordData);
        newRecordData.record[which] = newValue;

        window.onbeforeunload = function(e) {
            let text = "Are you sure you want to leave Flagship?";
            e.returnValue = text;
            return text;
        };

        this.setState(
            {
                modified: true,
                recordData: newRecordData
            }, this.checkRequired
        );
    }

    checkRequired() {
        
        let self = this;

        let requiredMissing = false;

        if ( self.state.name === "" ) {
            requiredMissing = true;
        }

        if ( self.state.childRequiredMissing === true ) {
            requiredMissing = true;
        }

        if (Flagship.config.records[self.props.route.type].extra1.required === true && empty(self.state.recordData.record.extra1)) {
            requiredMissing = true;
        }

        if (Flagship.config.records[self.props.route.type].extra2.required === true && empty(self.state.recordData.record.extra2)) {
            requiredMissing = true;
        }

        if (Flagship.config.records[self.props.route.type].extra3.required === true && empty(self.state.recordData.record.extra3)) {
            requiredMissing = true;
        }

        self.state.recordData.data.map(function(item) {
            if ((item.required === true || item.required === 1) && empty(self.state.fieldData[item.id])) {
                requiredMissing = true;
            }
        });

        self.setState({
            requiredMissing: requiredMissing
        });
    }

    hasContract(result) {
        this.setState({
           hasContract: result
        });
    }

    addError(fieldId) {

        let errors = this.state.errors;

        if (errors.indexOf(fieldId) === -1) {
            errors.push(fieldId);
        }

        this.setState({
            errors: errors
        });
    }

    clearError(fieldId) {

        let errors = this.state.errors;
        for (var i = errors.length - 1; i >= 0; i--) {
            if (errors[i] === fieldId) {
                errors.splice(i, 1);
            }
        }

        this.setState({
            errors: errors
        });
    }


    showRecordEditStatus() {
        if (this.state.modified === true) {

            return (
                <Button floated="right" disabled={this.state.requiredMissing || this.state.errors.length ? true : false}
                        primary onClick={this.saveAndExit}
                        content="Save Changes" />
            );

        } else {
            return (
                <span className="record-edit-status">No Changes to Save</span>
            );
        }
    }

    showLeaveConfirmation(nextLocation) {
        this.setState(
            {
                confirmExit: true,
                nextLocation: nextLocation
            }
        );
    }

    saveRecord(callback = null) {
        let self = this;

        //Save
        Flagship.post(
            'save-record/' + this.state.recordData.record.id + '/',
            self.state.recordData,
            function(response) {

                if ( response.data.success === true ) {
                    if (typeof callback === "function") {
                        callback(response);
                    }
                } else {
                    Flagship.error("Failed to save record.", self.state.recordData.record.id, self.props.userId);
                }
            },
            function(err) {
                Flagship.error("Failed to save record: " + err, self.state.recordData.record.id, self.props.userId);
            }
        );
    }

    saveAndExit() {
        let self = this;
        let newLocation = self.state.nextLocation;
        this.saveRecord(function() {

            let oldData = JSON.parse(localStorage.getItem('initialRecordData'));
            let newData = JSON.parse(JSON.stringify(self.state.recordData));
            localStorage.setItem('initialRecordData', JSON.stringify(newData));

            let changedValues = [];

            // Check for name change
            if(oldData.record.record_name !== newData.record.record_name) {
                changedValues.push({
                    "label": "Name",
                    "old" : oldData.record_name ,
                    "new" : newData.record_name,
                    "validation" : ""
                });
            }

            // Get extra fields
            if(oldData.record.extra1 !== newData.record.extra1) {
                changedValues.push({
                    "label": Flagship.config.records[self.props.route.type].extra1.label,
                    "old" : oldData.record.extra1 ,
                    "new" : newData.record.extra1,
                    "validation" : Flagship.config.records[self.props.route.type].extra1.validation
                });
            }

            if(oldData.record.extra2 !== newData.record.extra2) {
                changedValues.push({
                    "label": Flagship.config.records[self.props.route.type].extra2.label,
                    "old" : oldData.record.extra2 ,
                    "new" : newData.record.extra2,
                    "validation" : Flagship.config.records[self.props.route.type].extra2.validation
                });
            }

            if(oldData.record.extra3 !== newData.record.extra3) {
                changedValues.push({
                    "label": Flagship.config.records[self.props.route.type].extra3.label,
                    "old" : oldData.record.extra3 ,
                    "new" : newData.record.extra3,
                    "validation" : Flagship.config.records[self.props.route.type].extra3.validation
                });
            }

            // Check record data
            oldData.data.map(function(item, i) {
                if (
                    empty(oldData.data[i].field_value) ||
                    empty(newData.data[i].field_value) ||
                    oldData.data[i].field_value !== newData.data[i].field_value
                ) {

                    // If value does not match, add to changedValues array
                    if (!isEqual(oldData.data[i].field_value, newData.data[i].field_value) ) {


                    if (
                        oldData.data[i].type !== "user" ||
                        ( oldData.data[i].field_value !== null && oldData.data[i].field_value.id !== newData.data[i].field_value) ||
                        (oldData.data[i].field_value === null && !empty(newData.data[i].field_value))
                    ) {

                        changedValues.push({
                            "label": oldData.data[i].label,
                            "old": empty(oldData.data[i].field_value) ? '' : oldData.data[i].field_value,
                            "new": empty(newData.data[i].field_value) ? '' : newData.data[i].field_value,
                            "validation": newData.data[i].validation
                        });

                    }
        }
                }
            });

            window.onbeforeunload = null;

            self.setState({
                confirmExit: false,
                modified: false
            });

            Flagship.notify("Changes saved.", "success");
            Flagship.event(
                "change",
                changedValues,
                self.state.recordData.record.id,
                self.props.userId
            );

            if (newLocation) {
                browserHistory.push(newLocation);
            }
        });
    }

    cancelExit() {
        this.setState({
            confirmExit: false
        });
    }

    cancelLaunchDateChange() {
        this.setState({
            showLaunchDateModal: false
        });
    }

    onAddLineItem() {
        let recordData = Object.assign({},this.state.recordData);
        this.setState({
            recordData: recordData
        });
    }

    onStatusChange(e, data) {

        if (e !== null)
            e.preventDefault();

        let self = this;

        let additionalData = {};

        if (!empty(data.additional)) {
            additionalData = data.additional;
        }

        if ( self.state.recordData.record.record_status === data.value ) {
            // Do nothing
        } else {

            if(self.props.route.type === "io" && data.value === "launched" && empty(additionalData)) {
                // Get date launched first
                this.setState({
                   showLaunchDateModal:true
                });

            } else {
                Flagship.post(
                    "change-record-status/" + this.state.recordData.record.id + "/" + data.value,
                    additionalData,
                    function(response) {

                        if (response.data.success === true) {
                            let recordData = Object.assign({},self.state.recordData);
                            recordData.record.record_status = data.value;

                            self.setState({
                                recordData: recordData
                            }, function() {
                                Flagship.notify(self.props.route.niceName + " status changed.");
                                Flagship.event(
                                    "change-status-" + self.props.route.type,
                                    data.value,
                                    self.state.recordData.record.id,
                                    self.props.userId
                                );
                            });
                        } else {
                            Flagship.error(
                                "Failed to change status.",
                                self.state.recordData.record.id,
                                self.props.userId
                            );
                        }
                    }
                );
            }
        }
    }

    onChangeLaunchDate(data) {

        this.setState(
            {
                launchDate: data,
            }
        );
    }

    saveLaunchDate() {

        this.setState(
            {
            showLaunchDateModal: false
            },
            function() {
                this.onStatusChange(
                    null,
                    {
                        value: "launched",
                        additional: {
                            "closed": this.state.launchDate.unix()
                        }
                    }
                );
            }
        );
    }

    launchDateModal() {
        return (
            <Modal
                open={true}
                onClose={this.cancelLaunchDateChange}
                closeIcon
            >
                <Header icon='save' content='Enter Launch Date' />
                <Modal.Content>
                    <p>Please enter the date that this IO launched.</p>
                    <div className="small-field">
                        <div className="field-container clearfix">
                            <div className="ui fluid input">
                                <Icon name="calendar" color="grey" style={{marginTop: ".25em"}} size="large" />
                                <DatePicker
                                    autoFocus={true}
                                    onChange={this.onChangeLaunchDate}
                                    value={this.state.launchDate.format("MM/DD/YYY")}
                                    type="text"
                                />
                            </div>
                        </div>
                    </div>
                </Modal.Content>
                <Modal.Actions>
                    <Button primary onClick={this.saveLaunchDate}>
                        <Icon name='save' /> Save Launch Date
                    </Button>
                    <Button secondary onClick={this.cancelLaunchDateChange}>
                        <Icon name='cancel' /> Cancel Status Change
                    </Button>
                </Modal.Actions>
            </Modal>
        )
    }

    abandonChanges() {
        let originalRecordData = JSON.parse(localStorage.getItem("initialRecordData"));
        let newLocation = this.state.nextLocation;
        this.setState({
            confirmExit: false,
            modified: false,
            recordData: originalRecordData
        }, function() {
            if (newLocation) {
                browserHistory.push(newLocation);
            }
        });
    }

    duplicateRecord() {
        let self = this;

        Flagship.post(
            'duplicate-record/' + this.state.recordData.record.id,
            {},
            function(response) {
                if ( response.data.success === true ) {


                    let duplicateRecord = Object.assign({}, self.state.recordData.record);
                    duplicateRecord.record_status = "draft";
                    duplicateRecord.extra3 = '';

                    Flagship.event(
                        "create-" + self.state.recordData.record.record_type,
                        duplicateRecord,
                        response.data.record_id,
                        self.props.userId
                    );
                    Flagship.notify("Record duplicated.", "success");
                    browserHistory.push("/" + self.state.recordData.record.record_type + "/view/" + response.data.record_key);
                    self.getRecordData();
                } else {
                    Flagship.error("Failed to duplicate record.", self.state.recordData.record.id, self.props.userId);
                }
            },
            function(err) {
                Flagship.error("Failed to duplicate record: " + err, self.state.recordData.record.id, self.props.userId);
            }
        );
    }




    renderLineItems() {

        return (
          <div>
              {this.props.route.type === "rfp" && this.props.hideLineItems !== true ?
                  <LineItemBox
                      recordId={this.state.recordData.record.id}
                      recordKey={this.state.recordData.record.record_key}
                      recordStatus={this.state.recordData.record.record_status}
                      recordType={this.props.route.type}
                      onAddLineItem={this.onAddLineItem}
                      onStatusChange={this.getRecordData}
                      viewingChild={this.state.viewingChild}
                      onCloseModals={this.onCloseModals}
                      hasLineItems={this.hasLineItems}
                  />
                  : null
              }

              {this.props.route.type === "io" && this.props.hideLineItems !== true ?
                  <IoProductBox
                      recordId={this.state.recordData.record.id}
                      recordKey={this.state.recordData.record.record_key}
                      recordStatus={this.state.recordData.record.record_status}
                      recordType={this.props.route.type}
                      onAddLineItem={this.onAddLineItem}
                      onStatusChange={this.getRecordData}
                      viewingChild={this.state.viewingChild}
                      onCloseModals={this.onCloseModals}
                      hasIoProducts={this.hasLineItems}
                      onChangeAssignee={this.getRecordData}
                  />
                  : null
              }
          </div>
        );
    }



    render() {

        if( typeof this.state.recordData.record === "undefined") {
            return (
                <Table className="fade-in">
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell colSpan="5">
                                <Loader className="flagship-loader" active inline='centered' />
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>
            );
        } else {

            let editUrl = '/' + this.state.recordData.record.record_type + "/edit/" + this.state.recordData.record.record_key;
            let viewUrl = '/' + this.state.recordData.record.record_type + "/view/" + this.state.recordData.record.record_key;

            let showLeaveConfirmation = this.showLeaveConfirmation.bind(this);

            let recordId = this.state.recordData.record.id;
            let showRecordEditStatus = this.showRecordEditStatus.bind(this);

            let saveAndExit = this.saveAndExit.bind(this);
            let cancelExit = this.cancelExit.bind(this);
            let abandonChanges = this.abandonChanges.bind(this);
            let changeStatusOptions;

            if (this.props.route.type === 'io'  && (this.props.userRole === "dpm" || this.props.userRole === "admin")) {

                changeStatusOptions = [];

                for (let property in Flagship.config.records[this.props.route.type].statuses) {
                    if (Flagship.config.records[this.props.route.type].statuses.hasOwnProperty(property)) {

                        let option = {
                            "key": property,
                            "value": property,
                            "text": <Label
                                content={Flagship.config.records[this.props.route.type].statuses[property].label}
                                color={Flagship.config.records[this.props.route.type].statuses[property].color}/>
                        };
                        changeStatusOptions.push(option);
                    }
                }
            }


            return (
                <div className="fade-in">
                    <SingleRecordHeader
                        recordKey={this.state.recordData.record.record_key}
                        recordName={this.state.recordData.record.record_name}
                        recordType={this.state.recordData.record.record_type}
                        recordMarket={this.state.recordData.record.market}
                        recordStatus={this.state.recordData.record.record_status}
                        creatorFirstName={this.state.recordData.record.first_name}
                        creatorLastName={this.state.recordData.record.last_name}
                        creatorPhoto={this.state.recordData.record.photo}
                    />

                    <Header className="cf" attached="top">
                        <h2>{( this.props.route.mode === "edit" ? "Editing " : "" ) + this.props.route.niceName + " Details "}</h2>

                        {this.props.route.mode === "view" ?

                                <Button as={Link} to={editUrl} className="view-edit-record">
                                    <Icon name="edit"/>
                                    Edit
                                </Button>
                            :
                            <Button as={Link} to={viewUrl} className="view-edit-record">
                                <Icon name="eye"/>
                                View
                            </Button>
                        }

                        {this.props.route.mode === "view" ?
                        <Button onClick={this.duplicateRecord} className="view-edit-record">
                            <Icon name="copy"/>
                            Duplicate
                        </Button> : null }

                        <FavoriteIcon
                            recordId={recordId}
                            isFavorite={this.isFavorite()}
                        />

                        {this.props.route.mode === "view" ?
                            <SubscribeButton
                                recordId={recordId}
                                subscribers={this.state.recordData.subscribers}
                                recordNiceName={this.props.route.niceName}
                            />
                            :
                            showRecordEditStatus()
                        }
                    </Header>

                    <Segment className="record-main" attached>
                        <Grid stackable>
                            <Grid.Column mobile={16} tablet={16} computer={16} largeScreen={12} widescreen={12} width={16}>
                                <Grid stackable>
                                    <Grid.Column mobile={16} tablet={8} computer={10} largeScreen={10} widescreen={10} width={6}>
                                        {this.props.route.mode === "view" ?
                                            <SingleRecordView
                                                recordData={this.state.recordData}
                                                getRecordData={this.getRecordData}
                                                recordType={this.props.route.type}
                                                onAddLineItem={this.onAddLineItem}
                                                onStatusChange={this.getRecordData}
                                                viewingChild={this.state.viewingChild}
                                                onCloseModals={this.onCloseModals}
                                            />
                                                :
                                            <SingleRecordEdit
                                                recordId={this.state.recordData.record.id}
                                                recordData={this.state.recordData}
                                                editModeChange={this.editModeChange.bind(this)}
                                                onChangeName={this.recordNameChange.bind(this)}
                                                onChangeExtra={this.extraChange.bind(this)}
                                                saveAndExit={this.saveAndExit.bind(this)}
                                                router={this.props.router}
                                                route={this.props.route}
                                                modified={this.state.modified}
                                                showLeaveConfirmation={showLeaveConfirmation}
                                                requiredMissing={this.state.requiredMissing}
                                                errors={this.state.errors}
                                                name={this.state.recordData.record.record_name}
                                                extra1={this.state.recordData.record.extra1}
                                                extra2={this.state.recordData.record.extra2}
                                                extra3={this.state.recordData.record.extra3}
                                                addError={this.addError.bind(this)}
                                                clearError={this.clearError.bind(this)}
                                            />
                                        }
                                        {this.props.route.mode === "edit" && this.state.confirmExit === true ?
                                            <Modal
                                                open={true}
                                                onClose={cancelExit}
                                                closeIcon
                                            >
                                                <Header icon='save' content='Save Changes?' />
                                                <Modal.Content>
                                                    <p>You have unsaved changes. What would you like to do?</p>
                                                </Modal.Content>
                                                <Modal.Actions>
                                                    <Button primary onClick={saveAndExit}>
                                                        <Icon name='save' /> Save Changes
                                                    </Button>
                                                    <Button secondary onClick={abandonChanges}>
                                                        <Icon name='cancel' /> Abandon Changes
                                                    </Button>
                                                    <Button color='grey' onClick={cancelExit}>
                                                        <Icon name='dont' /> Cancel
                                                    </Button>
                                                </Modal.Actions>
                                            </Modal>
                                            : null
                                        }
                                        { this.state.recordData.record.record_status === "insertion" || this.state.recordData.record.record_status === "closed" ? this.renderLineItems() : null }
                                    </Grid.Column>
                                    <Grid.Column mobile={16} tablet={8} computer={6} largeScreen={6} widescreen={6} width={6}>
                                        {
                                            this.state.recordData.record.record_status === "trash" ?
                                                <div>
                                                    <Divider hidden />
                                                    <Header as="h3"><Icon size="mini" name="warning sign" color="red" />
                                                        Canceled {this.props.route.niceName}
                                                    </Header>
                                                    <Divider />
                                                    <p>
                                                        This {this.props.route.niceName} is canceled.
                                                    </p>
                                                    <Button
                                                        icon="undo"
                                                        content={ "Reactivate " + this.props.route.niceName }
                                                        onClick={this.onReactivateRecord}
                                                    />
                                                </div>
                                                :
                                                (this.state.recordData.record.record_type !== "rfp" ||
                                                    this.state.recordData.record.record_status !== "draft" ?

                                                    <Attachments
                                                        recordId={recordId}
                                                        recordType={this.props.route.type}
                                                        recordStatus={this.state.recordData.record.record_status}
                                                        recordName={this.state.recordData.record.record_name}
                                                        recordKey={this.state.recordData.record.record_key}
                                                        userId={this.props.userId}
                                                        onStatusChange={this.onStatusChange}
                                                        parent={this.state.recordData.record.parent}
                                                        businessClosed={this.state.recordData.record.closed}
                                                        onCancelRecord={this.onCancelRecord}
                                                        hasContract={this.hasContract}
                                                        niceName={this.props.route.niceName}
                                                    />
                                                    :
                                                    null
                                                )

                                        }

                                    </Grid.Column>
                                </Grid>

                                { this.state.recordData.record.record_status !== "insertion" && this.state.recordData.record.record_status !== "closed" ? this.renderLineItems() : null }
                            </Grid.Column>
                            <Grid.Column
                                className={
                                    this.state.recordData.record.record_status === "draft" ?
                                        "record-unsubmitted"
                                        :
                                        "comments-column"
                                }
                                mobile={16}
                                tablet={16}
                                computer={16}
                                largeScreen={4}
                                widescreen={4}
                                width={16}>
                                {
                                    this.state.recordData.record.record_status === "draft" ?
                                        <div className="record-comments">
                                            <Divider hidden />
                                            <Header as="h3"><Icon size="mini" name="warning sign" color="red" />
                                                Submit this {this.props.route.niceName}
                                            </Header>
                                            <Divider />
                                            <p>
                                                This {this.props.route.niceName} is still a draft. You must submit it for it to be received.
                                            </p>
                                            {this.state.hasLineItems === true &&
                                                (this.state.recordData.record.record_type !== "io" || this.state.hasContract === true) ?
                                                <div className="pulsing-button-wrap">
                                                    <Button
                                                        icon="send"
                                                        color="black"
                                                        content={ "Submit " + this.props.route.niceName }
                                                        onClick={this.onSubmitRecord}
                                                        className="pulsing-button-pulsing alternate"
                                                    />
                                                    <Button
                                                        style={{marginLeft:"1em"}}
                                                        icon="cancel"
                                                        content={ "Cancel " + this.props.route.niceName }
                                                        onClick={this.onCancelRecord}
                                                    />
                                                </div>
                                                :
                                                <div>
                                                <p>
                                                    {this.state.hasLineItems !== true ?
                                                        <span>
                                                            Add some
                                                            {this.state.recordData.record.record_type === "rfp" ?
                                                                ' line items '
                                                                :
                                                                ' products '
                                                            }
                                                            to get started.
                                                        </span>
                                                        :
                                                        <span>
                                                            <strong>Upload the signed contract</strong> in the box
                                                            {this.props.screenWidth >= 1200 ? ' to the left ' : ' above '}
                                                            first.
                                                        </span>
                                                    }
                                                </p>
                                                <Button
                                                    icon="cancel"
                                                    content={ "Cancel " + this.props.route.niceName }
                                                    onClick={this.onCancelRecord}
                                                />
                                                </div>
                                            }


                                        </div>
                                        :
                                        <CommentBox
                                            recordId={recordId}
                                        />
                                }
                            </Grid.Column>
                        </Grid>
                    </Segment>
                    <SingleRecordFiles
                        folder={this.props.route.type + '/' + this.state.recordData.record.record_key}
                        recordId={this.state.recordData.record.id}
                        userId={this.props.userId}
                    />

                    {this.state.showLaunchDateModal === true ? this.launchDateModal(): null}

                </div>
            )
        }

    }
}

SingleRecord.propTypes = {
    actions: PropTypes.object,
    token: PropTypes.string,
    niceName: PropTypes.string,
    username: PropTypes.string,
    userId: PropTypes.number
};

function mapStateToProps(state) {
  return {
    token: state.main.token,
    username: state.main.username,
    userId: state.main.userId,
    userRole:state.main.userRole,
    screenWidth: state.main.screenWidth
  };
}

function mapDispatchToProps(dispatch) {

  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SingleRecord);





// WEBPACK FOOTER //
// ./src/components/views/SingleRecord.js